setTimeout(() => {
    document.querySelector('.v5-attraction-promotion-entrance jds-button').addEventListener('click', function() {
        const title = this.parentElement.parentElement.parentElement.querySelector('.blocks-heading-content .blocks-content-heading .hidden p').textContent.trim();
        const event_parameters = {
                "module": "Promotion Entry",
                "button_name": this.textContent.trim(),
                "position": title,
                "link": location.origin + this.href
            }
        gaPushDataLayer("5.0_homepage_user_clicks", event_parameters);
    });
}, 20);